// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"44":"aecbc293","318":"75d75cb4"}[chunkId] + ".js";
};